/* eslint-disable no-underscore-dangle */
import BaseService from './BaseService';

class FormService extends BaseService {
  /**
   * Check if user is approver of the form for approval
   *
   * @param {string} type  whether OT or OB or etc.
   * @param {number} id    user id
   * @param {string} key   approval key
   */
  checkIfApprover(type, id, key) {
    return this.get(`${type}/check-approver`, { id, key });
  }

  /**
   * Check if user is owner of the record
   *
   * @param {string} type  whether OT or OB or etc.
   * @param {number} id    user id
   * @param {string} key   approval key
   */
  checkIfUser(type, id, key) {
    return this.get(`${type}/check-user`, { id, key });
  }

  /**
   * Get form data using approval key
   *
   * @param {string} type  whether OT or OB or etc.
   * @param {string} key   approval key
   */
  getFormDataByKey(type, key) {
    return this.get(`${type}/${key}`);
  }

  /**
   * Update current approval status of request
   *
   * @param {string} type
   * @param {string} action
   * @param {string} key
   * @param {number} approverId
   * @param {string} comments
   */
  updateApprovalStatus(type, action, key, approverId, comments = null) {
    return this.post(`/${type}/${action}`, { key, id: approverId, comments });
  }
}

export default FormService;
